import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var media_and_text_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M3 6v11.5h8V6H3Zm11 3h7V7.5h-7V9Zm7 3.5h-7V11h7v1.5ZM14 16h7v-1.5h-7V16Z" }) });
export {
  media_and_text_default as default
};
//# sourceMappingURL=media-and-text.js.map
